const CONSTANTS = {
  LOADING: "loading",
  FETCHING: "fetching",
  WARNING: "warning",
  CATEGORY_SCREEN: "category",
  DROP_OFF_MODAL: "drop-off-modal",
  DROP_OFF_SCREEN: "drop-off-screen",
  PAYMENT_METHOD_CARD: "card",
  PAYMENT_METHOD_APPLE: "apple_pay",
  PAYMENT_METHOD_VISA: "visa",
  PAYMENT_METHOD_TAP: "tap",
  PAYMENT_METHOD_LATER: "pay_later",
  PAYMENT_TAP_CARD: "tap_payment",
  PAYMENT_METHOD_KNET: "knet",
  ERROR_NO_NUMBER: "no_number_error",
  ERROR_NUMBER_CONFIRM: "number_commit_error",
  ERROR_PAYMENT_AUTHORIZATION: "payment_auth_error",
  ERROR_MERCHANT_VALIDATION: "merchant_validation_error",
  ERROR_APPLE_PAY: "apple_pay_error",
  APPLE_PAY_FEATURE: "web_apple_pay",
  SIM_SELECTION_DELIVER_SIM: "sim_selection_delivery",
  SIM_SELECTION_ALREADY_HAVE_SIM: "sim_selection_scan_sim",
  SIM_SELECTION_ESIM: "sim_selection_esim",
  SIM_SELECTION_PICK_UP_IN_STORE: "sim_selection_pick_in_store",
  DEFAULT_PREDEFINED_PLAN_SELECTION: 1,
  DEFAULT_PREDEFINED_BANNER_PLAN: "VMK-ATL-KD9-Hero",
  CONTENT_SERVICES: ["anghami", "starzplay", "osn", "blutv", "discovery", "ufc"],
  HOME_SCREEN: "find_a_number",
  SEARCH_NUMBER_SCREEN: "pick_number",
  MNP_SCREEN: "bring_your_own_number",
  PLAN_SELECTION_SCREEN: "pick_a_plan",
  OCR_FLOW_SCREEN: "ocr",
  PACI_SCREEN: "paci",
  SIGNATURE_SCREEN: "signature_screen",
  SELFIE_SCREEN: "selfie_screen",
  ELIGIBILITY_SCREEN: "eligibility",
  CREATE_ACCOUNT_SCREEN: "create_account",
  SIM_SELECTION_SCREEN: "sim_selection",
  PAYMENT_SUMMARY_SCREEN: "payment_summary",
  PAYMENT_OPTION_SCREEN: "Payment_option",
  PAYMENT_SCREEN: "payment",
  PAYMENT_SUCCESS_SCREEN: "payment_success",
  PAYMENT_FAILURE_SCREEN: "payment_failure",
  DELIVERY_SCREEN: "delivery",
  FIND_A_STORE_SCREEN: "find_a_store",
  ACTIVATION_SCREEN: "activation",
  ACTIVATION_SUCCESS_SCREEN: "activation_success",
  ACTIVATION_FAILURE_SCREEN: "activation_failure",
  COMMON_SCREEN: "common_sidebar",
  BUILD_VERSION: "0.1",
  REGULAR_PRODUCT_ATTR: "Regular",
  REGULAR_POSTPAID_PRODUCT_ATTR: "RegularPostPaid",
  TOP_UP_NO_LENGHT: 8,
  TOP_UP_MAX_VALUE: 250,
  TOP_UP_NUMBER_LENGTH: {
    "_ksa": 10,
    "_kw_onboard":8
  },
  TOP_UP_COUNTRY_CODE: {
    "_ksa": 966,
    "_kw_onboard": 965
  },
  PercentDiscount: "PercentDiscount",
  AmountDiscount: "AmountDiscount",
  QUICK_SERVICE: {
    PAYBILLS: "PayBills",
    QUICKTOPUP: "QuickTopup",
    EAUCTION: "EAuction",
    JOINNOW: "Join",
    ADVERTISEMENT: "Advertisement",
    PROTECTIONCHANNEL: "ProtectionChannel",
    SIMDEACTIVATION: "SimDeactivation",
  },
  AVAILABLE_PLAN_TYPES: [
    "DATA",
    "DATA-SOCIAL",
    "VOICE-IN-ROM",
    "VOICE-INT",
    "VOICE-LCL",
    "DATA-ROM",
    "SMS-LCL"
  ],
  OTP_TYPES: {
    "MNP": "mnp",
  },
  ESIM_FEATURE: "choose_esim"
};

export default CONSTANTS;
